import { render, staticRenderFns } from "./centerUser.vue?vue&type=template&id=6083109f&scoped=true&"
import script from "./centerUser.vue?vue&type=script&lang=js&"
export * from "./centerUser.vue?vue&type=script&lang=js&"
import style0 from "./centerUser.vue?vue&type=style&index=0&id=6083109f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6083109f",
  null
  
)

export default component.exports